var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVol3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343 4505 c-170 -46 -301 -185 -333 -354 -14 -74 -14 -3108 0 -3182 32 -169 156 -302 329 -353 50 -14 258 -16 2221 -16 1963 0 2171 2 2221 16 174 52 298 185 329 355 7 37 9 499 7 1365 -3 1454 3 1343 -70 1456 -71 111 -192 190 -319 208 -35 5 -531 10 -1103 10 l-1040 1 -185 221 c-102 122 -199 236 -216 255 l-31 33 -879 -1 c-723 0 -888 -3 -931 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVol3);
export default __webpack_public_path__ + "static/media/vol3.27d18fde0e59511095b56389bf149448.svg";
export { ForwardRef as ReactComponent };